module.exports = __webpack_public_path__ + "img/medical_icon02.f209cd63.png";